export default __webpack_public_path__ + "static/media/marketing.71a05d68.png";